// extracted by mini-css-extract-plugin
export default {"body":"search_body__r2NMt"};